import FilterSectionTitle from "./FilterSectionTitle.vue";
import WrapWithSection from "./WrapWithSection.vue";
import EmptySection from "./EmptySection.vue";
export default {
  name: "ListSection",
  components: {
    WrapWithSection,
    FilterSectionTitle,
    EmptySection
  },
  emits: ["selectAll"],
  props: {
    title: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    },
    searching: {
      type: Boolean,
      default: false
    },
    // Active search term, shown in the empty state when a search returns no matches.
    keyword: {
      type: [String, Array],
      default: ""
    },
    heightFromTop: {
      type: String,
      default: "0px"
    }
  },
  computed: {
    hasQuery() {
      return String(this.keyword ?? "").trim().length > 0;
    }
  }
};